import React from 'react'
import type { TaskInlineInputProps } from './TaskInlineInput'
import { TaskInlineInput } from './TaskInlineInput'
import { DateTimeInlineInput } from '@ztechapps/webui.date'

export const TaskDateInlineInput = ({ parentInputComponent, ...props }: TaskInlineInputProps) => {
  const ParentInput = parentInputComponent || TaskInlineInput

  return <ParentInput parentInputComponent={DateTimeInlineInput} {...props} />
}

export const TaskStartDateInlineInput = ({
  help = 'The date when the task started',
  name = 'startDate',
  label = 'Start Date',
  parentInputComponent,
  ...props
}: TaskInlineInputProps) => {
  const ParentInput = parentInputComponent || TaskDateInlineInput

  return <ParentInput help={help} label={label} name={name} {...props} />
}

export const TaskEndDateInlineInput = ({
  help = 'The date when the task is expected to end',
  name = 'endDate',
  label = 'Due Date',
  parentInputComponent,
  ...props
}: TaskInlineInputProps) => {
  const ParentInput = parentInputComponent || TaskDateInlineInput

  return <ParentInput help={help} label={label} name={name} {...props} />
}
